import { render, staticRenderFns } from "./addMaintainanceItem.vue?vue&type=template&id=34524a23"
import script from "./addMaintainanceItem.vue?vue&type=script&lang=js"
export * from "./addMaintainanceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports